import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconTwo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.5,
		y: 2,
		width: 15,
		height: 15,
		rx: 7.5,
		fill: "#5C5C5C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.75441 12.5L6.74562 11.542L9.03078 9.44141C9.62404 8.87451 9.94484 8.52295 9.94484 8.01758C9.94484 7.45068 9.51857 7.09912 8.9341 7.10352C8.33644 7.09912 7.94533 7.47705 7.94972 8.08789H6.69289C6.68849 6.84424 7.61134 6.04883 8.95168 6.04883C10.314 6.04883 11.2193 6.82666 11.2193 7.92969C11.2193 8.65479 10.8677 9.24805 9.55812 10.4346L8.59132 11.375V11.4102H11.3071V12.5H6.75441Z",
		fill: "white"
	})]
});
export default SvgIconTwo;
